export const FILE_OPTIONS = [
  { value: '.jpg', description: '.jpg' },
  { value: '.png', description: '.png' },
  { value: '.pdf', description: '.pdf' }
]

export const FILE_SIZE_TYPE = [
  { value: 'MB', description: 'MB' },
  { value: 'GB', description: 'GB' }
]

export const DATE_FORMAT = [
  { value: 'DD/MM/YYYY', description: 'DD/MM/AAAA' },
  { value: 'MM/DD/YYYY', description: 'MM/DD/AAAA' },
  { value: 'YYYY/MM/DD', description: 'AAAA/MM/DD' }
]
